var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4 1H3.25v3.6h7.5V10h-3.5l-.196.044C5.092 10.487 1 12.611 1 17.65c0 4.933 3.952 7.474 5.848 8.146l.292.104h3.61v4.8h3.6v-4.8h5.7v4.8h3.6v-4.8H31v-3.6h-7.35v-8.7H31V10h-7.35V4.6h6.75V1zM20.05 4.6h-5.7V10h5.7V4.6zm0 9v8.7h-5.7v-8.7h5.7zm-9.3 8.7v-8.7H7.674c-1.166.333-3.074 1.537-3.074 4.05 0 2.56 1.952 4.105 3.192 4.65h2.958z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTct);
export default __webpack_public_path__ + "static/media/TCT.00ee238c876a884a6d4c6c73b0d715bd.svg";
export { ForwardRef as ReactComponent };